/* tslint:disable */
/* eslint-disable */
/* @relayHash d131e929acdcf580c2db3b4cc367e9d5 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SearchBarRefetchQueryVariables = {
    query: string;
    hasQuery: boolean;
    userId: string;
    hasUserId: boolean;
    localRecentHistoryItemIds?: Array<string | null> | null;
    fetchUserRecentHistoryItem?: boolean | null;
};
export type SearchBarRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"SearchBar_viewer">;
    };
};
export type SearchBarRefetchQuery = {
    readonly response: SearchBarRefetchQueryResponse;
    readonly variables: SearchBarRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasQuery",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "localRecentHistoryItemIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUserRecentHistoryItem",
    "type": "Boolean",
    "defaultValue": false
  }
],
v1 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "query"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SearchBarRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SearchBar_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "hasQuery",
                "variableName": "hasQuery"
              },
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchBarRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isSuggestionsFeatureEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEARCH_BAR_SUGGESTIONS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEARCH_BAR_SUGGESTIONS\")"
          },
          (v2/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasQuery",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "searchSuggestions",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeTypes",
                    "value": [
                      "POPULAR",
                      "CATEGORY",
                      "SELLER"
                    ]
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "SearchSuggestion",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "suggestions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchSuggestionList",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "terms",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchSuggestionTerm",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "term",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId"
                  }
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUserRecentHistoryItem",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "storageKey": null,
                        "args": (v3/*: any*/),
                        "concreteType": "RecentHistoryItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RecentHistoryItemsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "contemporaryTrackingString",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstPhotoWebPath",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "size",
                                        "value": "small"
                                      }
                                    ],
                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pdpURL",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "browseUrl",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "categoryCode",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "categoryPath",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "seller",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Seller",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "__typename",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "args": (v3/*: any*/),
                        "handle": "connection",
                        "key": "getRecentHistory_recentHistoryItems",
                        "filters": [
                          "excludeItemPks"
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SearchBarRefetchQuery",
    "id": "ferrum/254.0.0-2020-03-02T14:38:36.831Z/SearchBarRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '7beead14353d8fc89775b3c15627bd25';
export default node;
